// @ts-nocheck
/**
 * カテゴリ補正テーブル
 * 速度・防御の固定ステータスに影響
 * 複数カテゴリを持つ場合は合算する
 * @module twinKey/core/party/data/categoryModifiers
 */

export const CATEGORY_MODIFIERS = {
  // ============================================================
  // 高速系（速度+、防御-）
  // ============================================================
  '鳥':           { speed: 20, defense: -20, group: 'speed' },
  'カラス':       { speed: 20, defense: -20, group: 'speed' },
  'カモメ':       { speed: 20, defense: -20, group: 'speed' },
  'フェニックス': { speed: 20, defense: -20, group: 'speed' },
  'インセクト':   { speed: 15, defense: -15, group: 'speed' },
  'アリ':         { speed: 15, defense: -15, group: 'speed' },
  'スピリット':   { speed: 10, defense: -10, group: 'speed' },
  '天使':         { speed: 10, defense: -10, group: 'speed' },
  'エンジェル':   { speed: 10, defense: -10, group: 'speed' },
  '蛮族':         { speed: 10, defense: -10, group: 'speed' },
  'スネーク':     { speed: 10, defense: 0,   group: 'speed' },

  // ============================================================
  // バランス系（速度・防御ともに小補正）
  // ============================================================
  'ヒューマノイド': { speed: 5, defense: 5,  group: 'balance' },
  '魔導士':         { speed: 5, defense: 5,  group: 'balance' },
  'ウィザード':     { speed: 5, defense: 5,  group: 'balance' },
  'プリンセス':     { speed: 5, defense: 5,  group: 'balance' },
  '魔族':           { speed: 5, defense: 10, group: 'balance' },
  'デーモン':       { speed: 5, defense: 10, group: 'balance' },
  'シャドウ':       { speed: 5, defense: 10, group: 'balance' },

  // ============================================================
  // 基準系（補正なし）
  // ============================================================
  'ビースト':       { speed: 0, defense: 0, group: 'neutral' },
  '猫':             { speed: 0, defense: 0, group: 'neutral' },
  '狼':             { speed: 0, defense: 0, group: 'neutral' },
  '狸':             { speed: 0, defense: 0, group: 'neutral' },
  'コア・ビースト': { speed: 0, defense: 0, group: 'neutral' },

  // ============================================================
  // 耐久系（速度-、防御+）
  // ============================================================
  'マーメイド':     { speed: 0,   defense: 15, group: 'tank' },
  'リヴァイアサン': { speed: 0,   defense: 15, group: 'tank' },
  'ダークドウェラ': { speed: -5,  defense: 20, group: 'tank' },
  'アビスソウル':   { speed: -5,  defense: 20, group: 'tank' },
  'ゴースト':       { speed: -5,  defense: 15, group: 'tank' },
  'プラント':       { speed: -10, defense: 20, group: 'tank' },
  'ドラゴン':       { speed: -10, defense: 30, group: 'tank' },
  'ワイバーン':     { speed: -10, defense: 30, group: 'tank' },
  '海竜':           { speed: -10, defense: 30, group: 'tank' },
  'スライム':       { speed: -5,  defense: 40, group: 'tank' },
  '粘液獣':         { speed: -5,  defense: 40, group: 'tank' },
  'ゴーレム':       { speed: -20, defense: 50, group: 'tank' },
  'マシン':         { speed: -20, defense: 50, group: 'tank' },
  'ガーディアン':   { speed: -20, defense: 50, group: 'tank' },

  // ============================================================
  // 勢力/能力系（補正なし - 物語的意味のみ）
  // ============================================================
  'ソウルカース':       { speed: 0, defense: 0, group: 'faction' },
  'タイドウェーブ':     { speed: 0, defense: 0, group: 'faction' },
  'パペットマスター':   { speed: 0, defense: 0, group: 'faction' },
  'マグマフォージ':     { speed: 0, defense: 0, group: 'faction' },
  'エクラシア':         { speed: 0, defense: 0, group: 'faction' },
  '虚蝕':               { speed: 0, defense: 0, group: 'faction' },
  'スカイレジェンド':   { speed: 0, defense: 0, group: 'faction' },
  'ウィング・トリビューン': { speed: 0, defense: 0, group: 'faction' },
  'ディープシャドウ':   { speed: 0, defense: 0, group: 'faction' },
  'ライバル':           { speed: 0, defense: 0, group: 'faction' },
  'トラベラー':         { speed: 0, defense: 0, group: 'faction' },
  'ルミナフォース':     { speed: 0, defense: 0, group: 'faction' },
  '鎖':                 { speed: 0, defense: 0, group: 'faction' },
  'ポイズンウェイル':   { speed: 0, defense: 0, group: 'faction' },
  'ブラック・オラクル': { speed: 0, defense: 0, group: 'faction' },
};

/**
 * カテゴリ補正を取得
 * @param {string} category - カテゴリ名（【】なし）
 * @returns {{ speed: number, defense: number }}
 */
export function getCategoryModifier(category) {
  return CATEGORY_MODIFIERS[category] || { speed: 0, defense: 0 };
}

/**
 * カテゴリ文字列をパース
 * "【ドラゴン】【炎】" → ["ドラゴン", "炎"]
 * @param {string} categoryStr - カテゴリ文字列
 * @returns {string[]}
 */
export function parseCategories(categoryStr) {
  // 文字列以外の場合は空配列を返す
  if (!categoryStr || typeof categoryStr !== 'string') return [];
  const matches = categoryStr.match(/【([^】]+)】/g) || [];
  return matches.map(m => m.replace(/[【】]/g, ''));
}

/**
 * 複数カテゴリの合計補正を計算
 * @param {string} categoryStr - カテゴリ文字列
 * @returns {{ speed: number, defense: number }}
 */
export function getTotalCategoryModifier(categoryStr) {
  const categories = parseCategories(categoryStr);

  let totalSpeed = 0;
  let totalDefense = 0;

  for (const cat of categories) {
    const mod = getCategoryModifier(cat);
    totalSpeed += mod.speed;
    totalDefense += mod.defense;
  }

  return { speed: totalSpeed, defense: totalDefense };
}
